import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setLemonLawFee } from '../../redux/modules/titlefees';
import Dropdown from '../../components/Dropdown';
import precise from '../../modules/precise';
import getLemonLawDropdownOptions from '../../modules/getLemonLawDropdownOptions';
import TextInput from '../../components/TextInput';

class LemonLaw extends Component {
  constructor(props) {
    super(props);
    this.onValueSelect = this.onValueSelect.bind(this);
  }

  onValueSelect(event) {
    const value = event.target.value;
    const label = this.getOptions()[event.target.selectedIndex][0];
    this.props.setLemonLawFee(precise(value), value, label);
  }

  getOptions() {
    return getLemonLawDropdownOptions(this.props);
  }

  render() {
    const { lemonLawFeeSelectedValue, lemonLawFee, lemonLawFeeSelectedValueLabel } = this.props;
    return (
      <div className="Row Title-feeRow">

        <TextInput
          id="Tsub3"
          data-id="lemonLawTotal"
          tooltip="Lemon Law Total"
          value={lemonLawFee}
          readOnly
          className="Row-total"
          tabIndex="-1"
        />

        <Dropdown
          id="LemonLaw"
          data-tooltip="Required on new vehicles (MCO) except exempt."
          options={this.getOptions()}
          onChange={this.onValueSelect}
          selectedValue={lemonLawFeeSelectedValue}
          className="Dropdown Row-dropdown no-print"
        />

        <b className="print-label print-only">{lemonLawFeeSelectedValueLabel}</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedVehicleValue: state.registration.selectedVehicleValue,
    selectedTitleVariables: state.titlefees.selectedTitleVariables,
    lemonLawFee: state.titlefees.lemonLawFee,
    lemonLawFeeSelectedValue: state.titlefees.lemonLawFeeSelectedValue,
    lemonLawFeeSelectedValueLabel: state.titlefees.lemonLawFeeSelectedValueLabel,
  };
};

export default connect(mapStateToProps, { setLemonLawFee })(LemonLaw);
